
































































import { defineComponent, getCurrentInstance, onMounted } from "vue";
import OmtTextSignature from "@/components/Atoms/omt-text-signature.vue";
import HealthProgramsSwiper from "@/components/Organisms/HealthPrograms/HealthProgramsSwiper.vue";

const coverImage = process.env.VUE_APP_BASE_URL + "images/health_programs/Omint_60mais.png";

export default defineComponent({
  components: {
    OmtTextSignature,
    HealthProgramsSwiper
  },
  setup() {
    const context = getCurrentInstance().proxy;

    onMounted(async () => {
      context.$root.$emit("hide-loading");
    });

    return {
      coverImage
    };
  }
});
